import sharpenUpsellStyles from './styles/sharpen-upsell-styles';
import { BaseComponent } from '../base-component/base-component';
import { ProductCardData } from '../product-card/product-card-display';
import { css, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Displays a cart product summary inside the Sharpen upsell modal.
 * Shows the product image, offer type badge, title and total price.
 */
@customElement('mhecomm-sharpen-upsell-modal-cart-product')
export class SharpenUpsellModalCartProduct extends BaseComponent {
  static styles = [
    sharpenUpsellStyles,
    css`
      img {
        width: 120px;
      }
    `,
  ];

  /**
   * The cart product to display.
   */
  @property({ type: Object })
  product?: ProductCardData;

  renderComp(): TemplateResult {
    if (!this.product) {
      return html`${nothing}`;
    }

    return html`
      <div class="d-flex flex-row align-items-start gap-2">
        <div class="flex-shrink-0">
          <img src="${this.product.image}" class="img-fluid object-fit-contain" alt=${this.product.title} />
        </div>
        <div class="flex-grow-1">
          <div class="row gy-1">
            <div>
              <span id="upsell-parent-title" class="sharpen-title">
                <b>${this.product.title}</b> was added to your cart.
              </span>
            </div>
            <div>
              <span id="upsell-parent-offer-type">
                ${this.product.offerType?.replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>
            </div>
            <div>
              <span id="upsell-parent-price">$${this.product.totalPrice?.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-sharpen-upsell-modal-cart-product': SharpenUpsellModalCartProduct;
  }
}
